export const fullName = (firstName, lastName) => {
  return `${firstName} ${lastName}`;
};
